import Actions from './action';
export const initState = {
	editCampaignLoading: false,
	domainListLoading: false,
	domainList: [],
};

const affiliateByIDReducer = (state = initState, action) => {
	switch (action.type) {
		case Actions.types.GET_DOMAINS_STARTED: {
			return {
				...state,
				domainListLoading: true,
			};
		}
		case Actions.types.GET_DOMAINS_SUCCESS: {
			return {
				...state,
				domainListLoading: false,
				domainList: (action.response || []).map((domain, i) => {
					return {
						key: i + 1,
						domainName: domain.domainName,
						domainId: domain.domainId,
					};
				}),
			};
		}
		case Actions.types.GET_DOMAINS_FAIL: {
			return {
				...state,
				domainListLoading: false,
				domainList: [],
			};
		}
		case Actions.types.EDIT_CAMPAIGN_STARTED: {
			return {
				...state,
				editCampaignLoading: true,
			};
		}
		case Actions.types.EDIT_CAMPAIGN_SUCCESS: {
			return {
				...state,
				editCampaignLoading: false,
			};
		}
		case Actions.types.EDIT_CAMPAIGN_FAIL: {
			return {
				...state,
				editCampaignLoading: false,
			};
		}

		default:
			return state;
	}
};

export default affiliateByIDReducer;
